import {
  countTilesByPricingProduct,
  type TILE_SIZES,
} from '@mixtiles/web-backend-shared'
import countBy from 'lodash/countBy'
import uniq from 'lodash/uniq'
import { PRODUCT_TYPES } from 'services/ProductTypeState'
import type { TilesStore } from 'stores/tilesStore/TilesStore'
import { CenterpieceTileStore } from 'stores/tilesStore/tiles/CenterpieceTileStore'
import { SinglePhotoTileStore } from 'stores/tilesStore/tiles/SinglePhotoTileStore'
import { TILES_CART_ITEM_ID, type TilesCartItem } from '../../CartItem'
import { createBaseCartMetadata } from '../CartItemAdapter.utils'
import { computeTilesWarnings } from './tilesWarnings'
import {
  selectBackgroundPhotoTile,
  selectMainPhotoTile,
  tileToThumbData,
} from './tilesThumb'

export function buildTilesCartItemFromTiles(
  tilesStore: TilesStore
): TilesCartItem | null {
  const tiles = tilesStore.tiles
  if (tiles.length === 0) return null

  const warnings = computeTilesWarnings(tiles)
  const regularTiles = tiles.filter(
    (tile) => !(tile instanceof CenterpieceTileStore)
  )
  const centerpiecesCount = tiles.length - regularTiles.length

  const photoTiles = tiles.filter(
    (tile): tile is SinglePhotoTileStore => tile instanceof SinglePhotoTileStore
  )
  const mainPhotoTile = selectMainPhotoTile(photoTiles)
  const otherPhotoTiles = mainPhotoTile
    ? photoTiles.filter((tile) => tile !== mainPhotoTile)
    : []
  const backgroundTile = mainPhotoTile
    ? selectBackgroundPhotoTile(mainPhotoTile, otherPhotoTiles)
    : null

  return {
    id: TILES_CART_ITEM_ID,
    productType: PRODUCT_TYPES.CLASSIC,
    quantity: 1,
    ...(warnings.length > 0 && { warnings }),
    metadata: {
      ...createBaseCartMetadata(),
      thumb: mainPhotoTile ? tileToThumbData(mainPhotoTile) : null,
      backgroundThumb: backgroundTile ? tileToThumbData(backgroundTile) : null,
      tilesCount: tiles.length,
      tileSizes: countBy(regularTiles, (tile) => tile.tileSize) as Record<
        TILE_SIZES,
        number
      >,
      centerpiecesCount,
      materialTypes: uniq(tiles.map((tile) => tile.materialType)),
      frameColors: uniq(tiles.map((tile) => tile.frameColor)),
      pricingProducts: countTilesByPricingProduct({ tiles }),
    },
  }
}
